// extracted by mini-css-extract-plugin
export default {"search-line":"masterManagement_search-line__soJWV","input-service":"masterManagement_input-service__O140B","btn":"masterManagement_btn__KX5fW","img":"masterManagement_img__14bOn"};